import type { TypedHExpandButton } from './-HExpandButton';
import RawHExpandButton from './HExpandButton.vue';
export * from './-HExpandButton';
export const HExpandButton = RawHExpandButton as typeof TypedHExpandButton;
